import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '../../mui-styles-bridge.js';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Radio from '@mui/material/Radio';
import ListItemText from '@mui/material/ListItemText';
import { addPageData } from '../../store/form/actions';
import Comment from './Comment';

const styles = (theme) => ({
  checkbox: {
    marginRight: 40,
    color: '#afafaf',
  },
  listtext: {
    fontSize: '13px',
  },
  checked: {},
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
});

class Singlechoice extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      single_answer: '',
    };
  }

  componentDidMount() {
    let answer_data = this.props.form.answer_data[this.props.data.key];
    if (answer_data && answer_data.answer) {
      let index = this.findIndex(
        this.props.form.answer_data[this.props.data.key].answer[0],
        this.props.data.data
      );
      // console.log(index)
      this.setState({ single_answer: index });
    } else {
      if (
        this.props.data.auto.toString() &&
        !this.props.form.answer_data[this.props.data.key]
      ) {
        let index = this.findIndex(this.props.data.auto, this.props.data.data);
        this.setState({ single_answer: index });
        this.props.dispatchaddPageData(
          this.props.data.key,
          typeof this.props.data.auto[0] == 'object'
            ? this.props.data.auto
            : [this.props.data.auto],
          this.props.data.question_text
        );
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //if ((this.props.data.auto.toString()) && !this.props.form.answer_data[this.props.data.key]) {
    //console.log(prevProps.data.auto, this.props.data.auto)
    if (this.props.data.auto != prevProps.data.auto) {
      //if (this.props.data.auto && !this.props.form.answer_data[this.props.data.key]) {
      let index = this.findIndex(this.props.data.auto, this.props.data.data);
      this.setState({ single_answer: index });
      this.props.dispatchaddPageData(
        this.props.data.key,
        typeof this.props.data.auto[0] == 'object'
          ? this.props.data.auto
          : [this.props.data.auto],
        this.props.data.question_text
      );
      //}
    }
  }

  findIndex = (data, container) => {
    function hasObject(element, target) {
      // Check if element matches target exactly (both as strings)
      if (element.toString() == target.toString()) {
        return true;
      }
      // Also check if target matches the value part of an option array
      // Options are formatted as [value, label], so element[0] is the value
      if (Array.isArray(element) && element[0] === target) {
        return true;
      }
      // Handle case where target is an array and we need to match just the value
      if (
        Array.isArray(target) &&
        Array.isArray(element) &&
        element[0] === target[0]
      ) {
        return true;
      }
      return false;
    }

    let i = container.findIndex((n) => {
      let a = hasObject(n, data);
      if (a == true) {
        return true;
      }
    });
    return i;
  };
  handleChange = (index) => (event) => {
    this.setState({ single_answer: index });

    this.props.getDataFromComponent(
      { single_answer: index },
      this.props.data.key,
      this.props.data.question_text,
      this.props.data.data
    );
  };

  doNothing = () => {};

  render() {
    const { classes, form, data } = this.props;

    try {
      return (
        <div className={classes.root}>
          <List component="nav">
            {this.props.data.data.map((n, i) => {
              return (
                <ListItem
                  key={`${data.key}-${i}`}
                  dense
                  button
                  onClick={
                    this.props.data.read_only == true
                      ? this.doNothing()
                      : this.handleChange(i)
                  }
                >
                  <Radio
                    disabled={this.props.data.read_only}
                    checked={this.state.single_answer === i}
                    onChange={
                      this.props.data.read_only == true
                        ? this.doNothing()
                        : this.handleChange(i)
                    }
                    value={i}
                    id={`single-choice-${this.props.data.key}`}
                    classes={{
                      root: this.props.data.style || classes.checkbox,
                      checked: classes.checked,
                    }}
                  />

                  <div>
                    {/*<div style={{textAlign:'left',display:'inline'}}>*/}
                    {/*<ListItemText className={classes.listtext}  primary={`${n[0]}:`} />*/}

                    {/*</div>*/}
                    <div style={{ textAlign: 'left', display: 'inline' }}>
                      <ListItemText
                        className={classes.listtext}
                        disableTypography={true}
                        primary={
                          <p
                            id={`${data.key}-${i}-answer-text`}
                            style={{
                              marginBottom: 0,
                              fontWeight: 'normal',
                            }}
                          >
                            {n[1]}
                          </p>
                        }
                      />
                    </div>
                  </div>
                </ListItem>
              );
            })}
          </List>
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form,
  };
};

const mapDispatchToProps = {
  dispatchaddPageData: (key, answer, question_text) =>
    addPageData({ key, answer, question_text }),
};

Singlechoice.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Singlechoice));
